import { KeyDisplayPair } from "../../models/interfaces/key-value";

const MultiProjectDropdownOptions: KeyDisplayPair<string, string>[] = [
    { key: "SHAB", display: "SHAB" },
    { key: "SHO", display: "SHO" },
    { key: "revision_treegram", display: "Révisions Treegram" }
];

export default MultiProjectDropdownOptions;